import { ConfigProvider, Button, theme, ThemeConfig, ButtonProps } from 'antd'
import { colorBgBrandless, colorTextDisable, darkenRate, error } from 'src/app/themes/primaryThemeDefault'
import tinycolor from 'tinycolor2'
const { useToken } = theme

const DeleteButton = (props: ButtonProps) => {
  const { children } = props
  const { token } = useToken()

  const modifiedTheme: ThemeConfig = {
    token: {
      ...token,
      colorPrimary: error,
      colorPrimaryHover: tinycolor(error).darken(darkenRate).toHexString(),
    },
    components: {
      Button: {
        defaultHoverBorderColor: `${tinycolor(error).darken(darkenRate).toHexString()}`,
        colorPrimary: error,
        colorBgContainerDisabled: colorBgBrandless,
        colorBgContainer: error,
        borderRadiusLG: 8,
        borderRadiusSM: 6,
        borderRadiusXS: 4,
        defaultBorderColor: error,
        defaultGhostBorderColor: error,
        defaultGhostColor: error,
        colorPrimaryActive: error,
        colorPrimaryTextActive: error,
        colorTextDisabled: colorTextDisable,
      },
    },
  }

  return (
    <ConfigProvider theme={modifiedTheme}>
      <Button type='default' size='middle' ghost {...props}>
        {children}
      </Button>
    </ConfigProvider>
  )
}

export default DeleteButton
